"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const functional_red_black_tree_1 = __importDefault(require("functional-red-black-tree"));
const reselect_1 = require("reselect");
const selectors_1 = require("@zedoc/selectors");
const compare_1 = require("@zedoc/compare");
const forEach_1 = __importDefault(require("lodash/forEach"));
const identity = (x) => x;
function createResourcesSelectorFactory(storageKey) {
    let resourcesTree = (0, functional_red_black_tree_1.default)(compare_1.compare);
    // TODO: Alternatively we could use custom middleware to capture
    //       actions that are mutation the corresponding branch of state tree.
    const selectResourcesDb = (state) => {
        const resourcesDb = state.ddp && state.ddp[storageKey];
        resourcesTree.forEach((key, resource) => {
            if (!resourcesDb || !resourcesDb[resource.id]) {
                resourcesTree = resourcesTree.remove(key);
            }
        });
        (0, forEach_1.default)(resourcesDb, (resource, id) => {
            if (!resourcesTree.get(resource.request)) {
                resourcesTree = resourcesTree.insert(resource.request, { id });
            }
        });
        return resourcesDb;
    };
    return (selectRequests, mapValue = identity) => (0, reselect_1.createSelector)((0, reselect_1.createSelector)(selectResourcesDb, (resourcesDb) => (0, selectors_1.memoizeMapValues)((request) => {
        if (!request) {
            return mapValue({
                // NOTE: If resource is not required, we consider it "ready".
                //       We use this to distinguish between situation when
                //       resource is not present in storage yet vs. resource
                //       was never requested in the first place.
                ready: true,
            });
        }
        const resource = resourcesTree.get(request);
        if (resource) {
            return mapValue(resourcesDb[resource.id], resource.id);
        }
        return mapValue(null);
    })), selectRequests, (mapValues, resources) => mapValues(resources));
}
exports.default = createResourcesSelectorFactory;
//# sourceMappingURL=createResourcesSelectorFactory.js.map